import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { ThemeProvider } from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// The width of the thin scrollbar in this browser, as --sbw: the menu frame above a scrolling list keeps this much free on its
// right, so the list's cards and the menu frame end at the same line (the list reserves that space for its scrollbar).
try {
  const probe = document.createElement('div');
  probe.style.cssText = 'position:absolute;top:-999px;width:100px;height:50px;overflow-y:scroll;scrollbar-width:thin;visibility:hidden';
  document.body.appendChild(probe);
  document.documentElement.style.setProperty('--sbw', `${probe.offsetWidth - probe.clientWidth}px`);
  document.body.removeChild(probe);
} catch { /* the css falls back to a fixed width */ }